export class CdTaskTypes {

    static PkCompleteTypeID = "864d7962-f321-464c-ad68-9186fb2e610c";

    // из другого модуля, не удалось разделить
    static PkConsiderationTypeID = "e230b87d-d837-4448-bcd3-a018acdda81b";
    static PkUksApprovalTaskTypeID = "e135de09-4f50-4d2b-b29b-11ccde5aaefc";
    static PkProjectGroupApprovalTaskTypeID = "a5d25a39-042a-4bbb-93cf-2cbbe3924fd0";
    static PkGipApprovalTaskTypeID = "5f132e2c-0e77-49c2-9cc1-6623b332ba98";
    static PkOspApprovalTaskTypeID = "f3562560-8d12-4efe-8471-57b5a726c984";
    static PkDepProductApprovalTaskTypeID = "ca4842e0-3f6f-429b-990e-4c78413e2221";
    static PkExternalApprovalTaskTypeID = "a840f4f8-433a-42fd-8428-833c162de75b";
    static PkStartAcquaintanceProcessTechDocTaskTypeID = "291aff62-8e24-4d12-9669-44d8accd3aca";
    static PkExecutiveDocumentationInitializingTypeID = "91AEA9E4-44F8-45B9-952F-35A1F989F7A3";
    static PkTDComissionOnRenovationTypeID = "FFF72896-FED2-4C89-8B1D-0300A4406A71";
    static ArPreparationForSigningTypeID = "8ae557ff-ca56-4c4e-9930-badf6bc84163";
    static PkSigningTypeID = "8D4A0809-7B22-404E-810A-C75FA461034C";
    static PkPersonnelDocumentCuratorReviewingTypeID = "8f3bf968-feb5-45e8-8bfd-ca7321fb03d7";
    static PkPersonnelDocumentSigningTypeID = "9bc786d9-dbf8-4822-bb50-9f29d98615a7";
    static PkPersonnelDocumentEtkTransitionTypeID = "6d483723-ca60-4a16-921e-3702bfdfc000";
    static PkPersonnelDocumentCuratorRevocationAgreementTypeID = "18728975-1156-40fb-ae26-43c2a896592d";
    static PkPersonnelDocumentEmployeeRevocationAgreementTypeID = "726a4a7e-4a4c-4ce4-b549-4e41650c524b";
    static ArPowerOfAttorneyExecutionTaskTypeID = "abcf2062-b636-4a83-a6c3-1015bcaa98fb";
    static ArApproveUDOTypeID = "1b494f13-3357-4b95-8511-d7737800d412";
    static ArPrintingTheContractTypeID = "37cbf2a2-8eb6-4f54-b840-6b5d7c445ba1";
    static ArEditBeforeSigningTypeID = "71facfac-a2ef-4bdb-bf86-25cd5106c164";
    static ArSigningTypeID = "451d16fc-4162-4492-a6f5-9bf0d829da53";

    static PkAWCORvrBlockFillTypeID = "4ac81e42-12f3-482d-ae23-97dc8a182f1e";
    static PkAWCORvrBlockFillConfirmationTypeID = "d3745fc1-f4b5-41b9-aebe-550f55d9bf15";
}